// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../action-list';
import {getSpaTypes} from '../../shared/repositories';

export const readSpaTypes = accountNumber =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const spaTypes = await getSpaTypes(accountNumber);

            dispatch({
                data: spaTypes,
                type: actions.UPDATE_CLAIM_SPA_TYPES
            });

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/spa/action-creators/get-spa-types.js